import type { AppSelectOption } from '../components/AppSelectDropdown';

export type ChecklistListItem = {
  id: string;
  name: string;
  activity_type_key: string;
  activity_type_label?: string;
};

export function buildChecklistSelectOptions(
  checklists: ChecklistListItem[],
  activityTypeKey: string | null | undefined,
): AppSelectOption[] {
  const typeKey = String(activityTypeKey ?? '').trim();
  const matching = checklists.filter((c) => c.activity_type_key === typeKey);
  const others = checklists.filter((c) => c.activity_type_key !== typeKey);
  const sorted = [...matching, ...others];

  return [
    { value: '', label: 'Keine Checkliste' },
    ...sorted.map((c) => ({
      value: c.id,
      label: c.name,
    })),
  ];
}

export function formatChecklistEditedRelative(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const diffMs = Date.now() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  const diffWeek = Math.floor(diffDay / 7);
  if (diffMin < 1) return 'gerade eben';
  if (diffMin < 60) return `vor ${diffMin} Min.`;
  if (diffHour < 24) return `vor ${diffHour} Std.`;
  if (diffDay < 7) return `vor ${diffDay} Tag${diffDay === 1 ? '' : 'en'}`;
  if (diffWeek < 5) return `vor ${diffWeek} Woche${diffWeek === 1 ? '' : 'n'}`;
  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
